var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.LfBlueTitleComponent, { attrs: { title: _setup.TEXT.title } }),
      _c("div", { staticClass: "step-wizard-container" }, [
        _c("div", { staticClass: "step-section" }, [
          _c("h3", { staticClass: "step-section-title" }, [
            _vm._v(_vm._s(_setup.TEXT.step1Title)),
          ]),
          _c("p", { staticClass: "step-description" }, [
            _vm._v(_vm._s(_setup.TEXT.step1Description)),
          ]),
          _c(
            "div",
            { staticClass: "download-button-container" },
            [
              _c(_setup.LfLabelButtonComponent, {
                staticClass: "download-btn",
                attrs: {
                  prependIcon: _setup.Icons.DOWNLOAD,
                  action: _setup.downloadImportExpedientTemplate,
                  text: _setup.TEXT.downloadTemplate,
                  variant: "outlined",
                  size: "md",
                  disabled: _setup.isDownloadingTemplate,
                },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "step-section" }, [
          _c("h3", { staticClass: "step-section-title" }, [
            _vm._v(_vm._s(_setup.TEXT.step2Title)),
          ]),
          _c("p", { staticClass: "step-description" }, [
            _vm._v(_vm._s(_setup.TEXT.step2Description)),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "step-section" },
          [
            _c("h3", { staticClass: "step-section-title" }, [
              _vm._v(_vm._s(_setup.TEXT.step3Title)),
            ]),
            _c("p", { staticClass: "step-description" }, [
              _vm._v(_vm._s(_setup.TEXT.step3Description)),
            ]),
            _c(_setup.FileUploaderComponent, {
              ref: "fileUploaderRef",
              attrs: {
                accept: _setup.ACCEPT_FILE_EXTENSIONS,
                maxFileSize: _setup.MAX_FILE_SIZE,
                dragDropText: _setup.TEXT.dragDropText,
                fileTypesText: _setup.TEXT.fileTypesText,
                uploadStatusText: _setup.TEXT.uploadStatusText,
                errorStatusText: _setup.TEXT.errorStatusText,
                errorMessage: _setup.importErrorMessage,
              },
              on: {
                fileSelected: _setup.onFileSelected,
                fileRemoved: _setup.onFileRemoved,
                uploadProgressComplete: _setup.onUploadProgressComplete,
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "dialog-actions-container" },
          [
            _c(_setup.LfActionsBarComponent, {
              staticClass: "action-buttons",
              attrs: { buttons: _setup.buttons, showKebabMenu: false },
              on: { "execute-action": _setup.onExecuteAction },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }